import { render, staticRenderFns } from "./InsNavLayout.vue?vue&type=template&id=bc54aacc&scoped=true&"
import script from "./InsNavLayout.vue?vue&type=script&lang=ts&"
export * from "./InsNavLayout.vue?vue&type=script&lang=ts&"
import style0 from "./InsNavLayout.vue?vue&type=style&index=0&id=bc54aacc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc54aacc",
  null
  
)

export default component.exports